import { configureStore } from '@reduxjs/toolkit';
import commonSlice from './CommonSlice';
import conversationSlice from './ConversationSlice';
import generationSlice from './GenerationSlice';
import UserSlice from './UserSlice';
import CognitoSlice from './CognitoSlice';

export const store = configureStore({
  reducer: {
    common: commonSlice,
    generation: generationSlice,
    conversation: conversationSlice,
    user: UserSlice,
    cognito: CognitoSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
